import * as Scrivito from "scrivito";
import LinkTitle from "^/utils/LinkTitle";
import { useMobileNavigation } from "^/Context/MobileNavigationContext";

function LinksListSecondLevel({ elems, className }) {
  return (
    <ul className="list-unstyled">
      {elems.map((item, index) => (
        <ListItem item={item} className={className} key={index} />
      ))}
    </ul>
  );
}

const ListItem = Scrivito.connect(({ item, className }) => (
  <li className={className}>
    <div className="d-flex w-100 justify-content-between nav-second-lvl-items">
      <LinkItem item={item} />
    </div>
  </li>
));

const LinkItem = Scrivito.connect(({ item }) => {
  const { dispatch } = useMobileNavigation();
  const isNavigationPage = item.get("isNavigationPage") === "yes";
  const url = isNavigationPage ? "#" : Scrivito.urlFor(item);
  return (
    <a
      href={url}
      onClick={() => {
        if (isNavigationPage) {
          dispatch({
            type: "updateCurrentPageId",
            payload: { pageId: item.id(), navLevel: 3 },
          });
        }
      }}
      className={`w-100 bg-blue p-3`}
    >
      <LinkTitle link={item} />
    </a>
  );
});

export default Scrivito.connect(LinksListSecondLevel);
